import React, { Component } from "react";
import { connect } from "react-redux";
import { useHistory } from "react-router-dom";
import { Link } from "react-router-dom";
import { BlockLink } from "../../components/Animations";
import arrowImg from "../../assets/images/budget/arrowGo.png";
import "./reports.css";
const ClientInfo = () => {
  const history = useHistory();
  const Reports = [
    {
      id: 1,
      link: "/asset_item_report",
      title: "All Items Report",
    },
    {
      id: 2,
      link: "/report_prefessional_team",
      title: "Professional Team Report",
    },
    {
      id: 3,
      link: "/report_all_insurance_products",
      title: "All Insurance Products",
    },
    {
      id: 4,
      link: "/report_asset",
      title: "Report Asset",
    },
    {
      id: 5,
      link: "/reports/budget",
      title: "Budget Report",
    },
    {
      id: 6,
      link:"/budget_detailed",
      title: "Budget Detailed",
    },
    {
      id: 7,
      link: "/add_asset",
      title: "Add Asset",
    },
    {
      id: 8,
      link: "/report_general_information",
      title: "Report - General Information",
    },
    {
      id: 9,
      link: "/income_report",
      title: "Income Report",
    },
    {
      id: 10,
      link: "/goals_report",
      title: "Goals Report",
    },
    {
      id: 11,
      link: "/insurance_report",
      title: "Insurance Report",
    },
    {
      id: 12,
      link: "/liabilities_credit_report",
      title: "Liabilities and Credit Report",
    },
    {
      id: 13,
      link: "/liquidity_report",
      title: "Liquidity Report",
    },
    {
      id: 14,
      link: "/net_worth_report",
      title: "Net Worth Report",
    },
    {
      id: 15,
      link: "/report_monthly_savings",
      title: "Report Monthly Savings",
    },
    {
      id: 16,
      link: "/social_security_report",
      title: "Social Security Report",
    },
    {
      id: 17,
      link: "/starting_a_business_report",
      title: "Starting a Business Report",
    },
    {
      id: 18,
      link: "/starting_a_business_report",
      title: "Subscription Report",
    },
  ];

  return (
    <React.Fragment>
      <div className="reportsMainSection">
        <h3 className="reportSelectHeading">Reports</h3>
        <div className="reportMain" >
          {Reports &&
            Reports.map((item, index) => (
              <div
                key={index}
                onClick={() => {
                  history.push(item.link);
                }}
                className="reportMaincards"
              >
                <div className="reportMaincardsInner" >
                  {" "}
                  <div className="reportMainHeader">
                    <span className="reportSelectheadingValue">{item.title}</span>
                  </div>
                  <div >
                    <img src={arrowImg} height={"14px"} alt={item.name} />{" "}
                  </div>
                </div>
              </div>
            ))}
        </div>
      </div>
      {/*  <div className="module-blocks">
        <BlockLink
          className="module-block-link"
          link="/asset_item_report"
          title="All Items Report"
        />
        <BlockLink
          className="module-block-link"
          link="/report_prefessional_team"
          title="Professional Team Report"
        />
        <BlockLink
          className="module-block-link"
          link="/report_all_insurance_products"
          title="All Insurance Products"
        />
        <BlockLink
          className="module-block-link"
          link="/report_asset"
          title="Report Asset"
        />
        <BlockLink
          className="module-block-link"
          link="/budget_report"
          title="Budget Report"
        />
        <BlockLink
          className="module-block-link"
          link="/reports/budgetDetails"
          title="Budget Detailed"
        />
        <BlockLink
          className="module-block-link"
          link="/add_asset"
          title="Add Asset"
        />
        <BlockLink
          className="module-block-link"
          link="/report_general_information"
          title="Report - General Information"
        />
        <BlockLink
          className="module-block-link"
          link="/income_report"
          title="Income Report"
        />
        <BlockLink
          className="module-block-link"
          link="/goals_report"
          title="Goals Report"
        />
        <BlockLink
          className="module-block-link"
          link="/insurance_report"
          title="Insurance Report"
        />
        <BlockLink
          className="module-block-link"
          link="/liabilities_credit_report"
          title="Liabilities and Credit Report"
        />
        <BlockLink
          className="module-block-link"
          link="/liquidity_report"
          title="Liquidity Report"
        />
        <BlockLink
          className="module-block-link"
          link="/net_worth_report"
          title="Net Worth Report"
        />
        <BlockLink
          className="module-block-link"
          link="/report_monthly_savings"
          title="Report Monthly Savings"
        />
        <BlockLink
          className="module-block-link"
          link="/social_security_report"
          title="Social Security Report"
        />
        <BlockLink
          className="module-block-link"
          link="/starting_a_business_report"
          title="Starting a Business Report"
        />
        </div> */}
    </React.Fragment>
  );
};

export default connect()(ClientInfo);
